import { PriceItem } from '@/features/common/components/Overview/types'
import { useAutomaticContainerConfiguration } from '@/features/pos/components/Cart/hooks/useAutomaticContainerConfiguration'
import { useChangeCartContainerItemQuantity } from '@/features/pos/components/Cart/hooks/useChangeCartContainerItemQuantity'
import { useChangeCartItemQuantity } from '@/features/pos/components/Cart/hooks/useChangeCartItemQuantity'
import { useEditAutomaticContainersModal } from '@/features/pos/components/Cart/hooks/useEditAutomaticContainersModal'
import CartItemDeleteConfirmationModal from '@/features/pos/components/Cart/parts/CartItemDeleteConfirmationModal'
import EmptyOrderPlaceholder from '@/features/pos/components/Cart/parts/EmptyOrderPlaceholder'
import Overview from '@/features/pos/components/Cart/parts/Overview'
import { ContainerItem } from '@/features/pos/components/Cart/parts/Overview/parts/CartContainerItem/types'
import { CartProductItem } from '@/features/pos/components/Cart/parts/Overview/parts/CartItem/types'
import { setCartItemToDeleteId } from '@/features/pos/components/Cart/utils/cart-item-to-delete-id'
import { FC, memo, useState } from 'react'
import { ScrollView } from 'react-native'

interface CartProps {
    items: CartProductItem[]
    containerItems: ContainerItem[]
    automaticContainersEnabled: boolean
    loaded: boolean
    priceItems?: PriceItem[]
    totalPrice?: string
}

const Cart: FC<CartProps> = ({ items, containerItems, automaticContainersEnabled, loaded }) => {
    const changeQuantity = useChangeCartItemQuantity()
    const changeContainerItemQuantity = useChangeCartContainerItemQuantity()
    const [expandedItemId, setExpandedItemId] = useState<string | null>(null)
    const { itemsWithFilteredAutomaticContainers, itemIdsWithAutomaticContainers } =
        useAutomaticContainerConfiguration({
            items,
            enabled: automaticContainersEnabled,
            loaded,
        })
    const handleEditAutomaticContainers = useEditAutomaticContainersModal({
        items,
        enabled: automaticContainersEnabled,
        loaded,
    })

    const handleToggleItem = (id: string) => {
        setExpandedItemId((current) => (current === id ? null : id))
    }

    return (
        <ScrollView contentContainerStyle={{ flexGrow: 1, paddingVertical: 16 }}>
            {itemsWithFilteredAutomaticContainers.length || containerItems.length ? (
                <Overview
                    items={itemsWithFilteredAutomaticContainers}
                    containerItems={containerItems}
                    onDelete={setCartItemToDeleteId}
                    onDeleteContainerItem={(id) => setCartItemToDeleteId(id, 'container')}
                    onChangeQuantity={changeQuantity}
                    onChangeContainerItemQuantity={changeContainerItemQuantity}
                    onEditAutomaticContainers={handleEditAutomaticContainers}
                    itemIdsWithAutomaticContainers={itemIdsWithAutomaticContainers}
                    expandedItemId={expandedItemId}
                    onToggleItem={handleToggleItem}
                />
            ) : (
                <EmptyOrderPlaceholder />
            )}
            <CartItemDeleteConfirmationModal />
        </ScrollView>
    )
}

export default memo(Cart)
